import colors from '../../../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    return {
        accountRecoveryIcon: {
            color: colors[mode].cardImageTextRBCHover,
            height: '24px',
            width: '24px',
            [theme.breakpoints.down('md')]: {
                height: '22px',
                width: '22px'
            },
            [theme.breakpoints.down('sm')]: {
                height: '20px',
                width: '20px'

            }
        },
        accountRecoveryInfo: {
            display: 'flex',
            gap: '8px',
            justifyContent: 'space-evenly',
            paddingLeft: '15px',
            [theme.breakpoints.down('sm')]: {
                gap: '0px',
            }
        },
        accountRecoveryOption: {
            '&:hover': {
                backgroundColor: colors[mode].skeletonInsightsBackground,
                border: `1px solid ${colors[mode].recoveryBorder}`,
                color: '#003168',
                cursor: 'pointer',
                opacity: 0.9
            },
            alignItems: 'center',
            border: `1px solid ${colors[mode].welcomeCardBorder}`,
            borderRadius: '2px',
            display: 'flex',
            flexDirection: 'row',
            fontFamily: 'Roboto',
            height: '74px',
            justifyContent: 'space-between',
            marginBottom: '12px',
            paddingRight: '12px',
            width: '100%',
            // [theme.breakpoints.down('md')]: {
            //     marginLeft: '2%',
            //     width: '98%'
            // },
            // [theme.breakpoints.down('sm')]: {
            //     paddingRight: '8px',
            //     width: '90%'
            // }
        },
        accountRecoveryOptionSelected: {
            backgroundColor: colors[mode].skeletonInsightsBackground,
            border: `1px solid ${colors[mode].recoveryBorder}`,
            color: '#003168',
        },

        accountRecoveryPhoneNumber: {
            color: colors[mode].mfaActiveBackground,
            fontSize: '1.25rem',
            fontWeight: 500,
            letterSpacing: '0.46px',
            lineHeight: '20px',
            marginLeft: '12px',
            [theme.breakpoints.down('md')]: {
                fontSize: '1.1rem',

            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '0.85rem',

            }
        },
        accountRecoveryType: {
            color: colors[mode].mfaActiveBackground,
            fontSize: '1.25rem',
            fontWeight: 500,
            letterSpacing: '0.46px',
            lineHeight: '20px',
            marginLeft: '12px',
            [theme.breakpoints.down('md')]: {
                fontSize: '1.1rem'
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '0.85rem'
            }
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            paddingLeft: '89%',

            [theme.breakpoints.down('sm')]: {
                paddingLeft: '80%',
            }
        },
        cardsContainer: {
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '16px',
            marginTop: '16px',
            minHeight: '182px',
            paddingLeft: '4%',
            width: '92.8%'
        },
        cardsContainerOne: {
            paddingTop: '5%'
        },
        cardTitle: {
            color: '#60666D',
            fontSize: '16px'
        },
        customLoader: {
            paddingTop: '18% !important',
            [theme.breakpoints.down('sm')]: {
                paddingTop : '32%',
            }
        },
        description: {
            color: '#60666D',
            fontSize: '0.875rem',
            letterSpacing: '0.17px',
            lineHeight: '1.25rem',
            textAlign: 'center'
        },
        helpText: {
            fontStyle: 'italic',
            padding: '16px 24px',
            [theme.breakpoints.down('sm')]: {
                padding: '16px 16px'
            }
        },
        introText: {
            padding: '16px 24px',
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '16px',
                paddingRight: '16px'
            }
        },

        nextButton: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                height: '32px',
                padding: '8px 16px',
                width: 'auto'
            }
        },
        nextButtonDisabled: {
            '&.MuiButton-root': {
                opacity: '50%'
            }
        },
        radio: {
            '&.Mui-checked': {
                color: colors[mode].recoveryIcon
            },
            color: colors[mode].primaryText
        },
        subTitle: {
            color: colors[mode].cardDescription,
            fontSize: '0.875rem',
            letterSpacing: '0.17px',
            lineHeight: '1.25rem'
        }
    }
}
